import React, { useState } from "react";
import PropTypes from "prop-types";
import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import i18n from "i18next";
import { CANADA_ENGLISH, CANADA_FRENCH } from "../../common/Constants";
import LanguageUtil from "../../utils/LanguageUtil";
import { publish } from "../../common/PubSub";

const LANGUAGES = [
  { code: CANADA_ENGLISH, label: "English", testId: "english" },
  { code: CANADA_FRENCH, label: "Français", testId: "french" },
];

const GlobalNavLanguage = ({ styles, t }) => {
  const [anchorElement, setAnchorElement] = useState(null);
  const [language, setLanguage] = useState(i18n.language);
  const isOpen = Boolean(anchorElement);

  const handleClose = () => {
    setAnchorElement(null);
  };

  const selectLanguage = (code) => {
    LanguageUtil.updateLanguage({ i18n }, code);
    publish("language", code);
    setLanguage(code);
    handleClose();
  };

  return (
    <>
      <IconButton
        aria-label="Language selection"
        aria-haspopup="true"
        aria-expanded={isOpen}
        onClick={(event) => setAnchorElement(event.currentTarget)}
        className={`${styles.navIconButton} ${
          isOpen ? styles.navIconButtonOpen : ""
        }`}
        data-testid="global-nav-language-button"
      >
        <LanguageIcon fontSize="small" />
      </IconButton>

      <Menu
        elevation={0}
        anchorEl={anchorElement}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          className: styles.languageMenuPaper,
          "data-testid": "global-nav-language-menu",
        }}
        MenuListProps={{ className: styles.languageMenuList }}
      >
        <Typography className={styles.languageMenuTitle}>
          {t("GlobalNavBar.languageMenu.title")}
        </Typography>
        {LANGUAGES.map(({ code, label, testId }) => {
          const isSelected = language === code;

          return (
            <MenuItem
              key={code}
              disableRipple
              selected={isSelected}
              onClick={() => selectLanguage(code)}
              className={`${styles.languageMenuItem} ${
                isSelected ? styles.languageMenuItemSelected : ""
              }`}
              data-testid={`global-nav-language-${testId}`}
            >
              {label}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

GlobalNavLanguage.propTypes = {
  styles: PropTypes.objectOf(PropTypes.string).isRequired,
  t: PropTypes.func.isRequired,
};

export default GlobalNavLanguage;
